import React from 'react';

const AboutCopyPod = () => (
  <div className="developer-pod-container">
    <div className="developer-pod-content">
      <p>
        I’m Andrew thanks for checking out my website! My career choice was to be a Developer, I have always had a
        passion for programming. For those of you who are not technical on this subject, it basically means that I’m a
        wizard! Well, maybe not a real wizard but the things I can do, really can be perceived as magic!
      </p>

      <blockquote
        id="about-quote"
        cite="https://www.goodreads.com/quotes/547452-magic-s-just-science-that-we-don-t-understand-yet"
      >
        “Magic&#39;s just science that we don&#39;t understand yet.” - Arthur C. Clarke
      </blockquote>
      <p>
        Sticking to the subject of science, that is what I studied. Computer Science to be exact. I’m a geek, when
        working with a computer. Just don’t expect me to be that good in a science lab! I think I am also one of the
        rare few developers out there, who actually knows how to design as well.
      </p>
      <p>
        I specialise in developing and building websites through programming. Although, I do like to play around in
        design tools like Adobe Photoshop CC, Adobe XD, Sketch, InVision Studio and Figma. I’m a gamer and i’m also
        really into anime and manga, so that is probably where all of my design passion has come from over the years :)
      </p>
      <p>
        I always prefer to have a custom design made from scratch. I very rarely use a pre made online theme, I feel
        like it&#39;s cheating and you just don’t get that same excitement, when you bring your own creation to life. I
        believe that your work is a real life reflection, of yourself and to that respect I like to be very creative
        with my ideas. It’s amazing going through the whole process from the concept, to the final product.
      </p>
      <p>
        When I work, I try to be unique and push the boundaries. I try to do things that have not been done before, and
        come up with new ways of doing them. So now that you know about me, check out my portfolio and head over to my
        contact page to shoot me a message.
      </p>
      <p>You can also see, more of my work on my, Github and Codepen profiles below.</p>
      <p>Peace!</p>
    </div>
  </div>
);

export default AboutCopyPod;
